import React, { useEffect, useContext } from 'react'
import TableRangeKilometers from '../../components/utils/tableRangeKilometers'
import { M_Button, M_Select, M_DrawerTableTextField, M_InputTextField, BufferService, LoadingContext } from 'src/components/M_Components'
import TableCostsCustomer from 'src/components/utils/tableCostsCustomer'
import { useTranslation } from 'react-i18next'
import { DeleteOutline } from '@mui/icons-material'

export default function RangeKilometers({ dataQuotes, setDataQuotes, rowCost, setRowCost, operation, tablesRange, setTablesRange, optionsZone, setOptionsZone, optionsRange, setOptionsRange, firstRowAdded, setFirstRowAdded, count, setCount }) {

  const bufferServicePriceTableDetail = new BufferService('PriceTableDetail')
  const ctx = useContext(LoadingContext)
  const { t } = useTranslation()

  const formRangeKilometers = [
    { Name: t("Name"), Type: 'string' },
  ]

  useEffect(() => {
    bufferServicePriceTableDetail.options().then((response) => {
      if (response.name === 'AxiosError') {
        ctx.toastMessages('error', response.response.data.Errors[0], '')
        return
      }
      const filteredOptions = response.filter((option) => !option.IsHiddenList)
      setOptionsRange(filteredOptions)
    })
  }, [])

  useEffect(() => {
    if (operation === 'edit') {
      const priceTableList = dataQuotes.get("PriceTableList")
      priceTableList.forEach((elem) => {
        elem.PriceTableDetailList.forEach((element, i) => {
          element.Id = element.Id
          element.id = i + 1
        })
      })

      dataQuotes.set("PriceTableList", priceTableList)
      setTablesRange(dataQuotes.get("PriceTableList"))
      setDataQuotes(new Map(dataQuotes))

      if (priceTableList && priceTableList.length > 0) {
        const newOptions = [...optionsZone]

        priceTableList.forEach(item => {
          item.Name = item.Name
          newOptions.push({ id: item.Id, label: item.Name, value: item.Name })
        })

        setOptionsZone(newOptions)

        setTablesRange([])
        const createdTablesEdit = []

        for (let i = 0; i < dataQuotes.get('PriceTableList').length; i++) { //está a criar as tabelas que vem do priceTableList
          const newTable = {
            id: dataQuotes.get('PriceTableList')[i].Id,
            Name: dataQuotes.get('PriceTableList')[i].Name,
            PricePlanId: dataQuotes.get('PriceTableList')[i].PricePlanId,
            PriceTableDetailList: priceTableList[i].PriceTableDetailList,
          }
          createdTablesEdit.push(newTable)
        }
        setTablesRange(createdTablesEdit)
        dataQuotes.set('PriceTableList', priceTableList)

        setDataQuotes(new Map(dataQuotes))
      }
    } else if (operation === 'create') {
      if (tablesRange.length === 0) {
        addDefaultTable()
        addLineZone()
      }
    }
  }, [])


  const addDefaultTable = () => {
    if (tablesRange.length === 0 || (tablesRange[0].Name && tablesRange[0].Name.trim() !== '')) {
      const newRow = {
        id: 1,
        Limit: 1,
      }
      const defaultColumnValues = {}
      optionsRange.forEach((option) => {
        defaultColumnValues[option.Header] = 0
      })
      const newTableName = ''
      const newTable = {
        id: tablesRange.length === 0 ? 1 : tablesRange[tablesRange.length - 1].id + 1,
        Name: newTableName,
        PriceTableDetailList: [newRow],
      }
      const newArray = [...tablesRange, newTable]
      setTablesRange(newArray)
      dataQuotes.set('PriceTableList', newArray)
      setDataQuotes(new Map(dataQuotes))
      setFirstRowAdded(true)
    } else {
      ctx.toastMessages('error', '', t("FillTableName"))
    }
  }

  const columnsRange = optionsRange.map((option) => ({
    field: option.Name,
    header: option.NormalizedName,
  }))

  const addRangeKilometers = (event, tableIndex) => {
    const optionName = event.target.value
    const tempTable = { ...tablesRange[tableIndex], Name: optionName }
    let tempOptions = []

    if (optionsZone.some((option) => option.id === tempTable.id)) {
      tempOptions = optionsZone.map((value) => {
        if (value.id === tempTable.id) {
          return { ...value, label: optionName, value: optionName }
        }
        return value
      })
    } else {
      tempOptions = [
        ...optionsZone,
        { id: tempTable.id, label: tempTable.Name, value: tempTable.Name },
      ]
    }

    setOptionsZone(tempOptions)

    const updatedTables = tablesRange.map((value) => {
      if (value.id === tempTable.id) {
        return tempTable
      }
      return value
    })
    setTablesRange(updatedTables)
    dataQuotes.set('PriceTableList', updatedTables)
    setDataQuotes(new Map(dataQuotes))
  }

  const removeTable = (tableIndex) => {
    let updatedTables = [...tablesRange]

    const tableName = updatedTables.find(obj => obj.id === tableIndex)?.Name

    updatedTables = updatedTables.filter(obj => obj.id !== tableIndex)
    setTablesRange(updatedTables)
    dataQuotes.set('PriceTableList', updatedTables)

    const updatedOptions = optionsZone.filter(option => option.label !== tableName)
    setOptionsZone(updatedOptions)

    setDataQuotes(new Map(dataQuotes))
  }

  const addLineToTable = (tableIndex) => {
    const tempTable = tablesRange[tableIndex]
    let Id = 1
    if (tempTable && tempTable.PriceTableDetailList.length > 0) {
      const maxId = Math.max(...tempTable.PriceTableDetailList.map((row) => row.id))
      Id = maxId + 1
    }
    const newRow = {
      id: Id,
    }

    const updatedTable = { ...tempTable }
    updatedTable.PriceTableDetailList = [...tempTable.PriceTableDetailList, newRow]

    const updatedTables = [...tablesRange]
    updatedTables[tableIndex] = updatedTable
    setTablesRange(updatedTables)
    dataQuotes.set('PriceTableList', updatedTables)
    setDataQuotes(new Map(dataQuotes))
  }

  const RowChangeValue = (index, newRowRange) => {
    const updatedTables = [...tablesRange]
    const updatedTable = { ...updatedTables[index], PriceTableDetailList: newRowRange }
    updatedTables[index] = updatedTable
    setTablesRange(updatedTables)
  }

  const addLineZone = () => {
    const newLine = {
      Id: count + 1,
      FromPriceZone: '',
      ToPriceZone: '',
      PriceTable: '',
    }

    setCount(newLine.Id)
    const getZones = dataQuotes.get("PricePlanDetailList") || []
    const newArray = [...getZones, newLine]
    dataQuotes.set("PricePlanDetailList", newArray)
    setDataQuotes(new Map(dataQuotes))
  }

  const handleZoneChange = (e, Id, field, isDrawer) => {
    const getZones = dataQuotes.get("PricePlanDetailList") || []
    const updatedLine = [...getZones]
    const targetIndex = updatedLine.findIndex(line => line.Id === Id)
    if (targetIndex !== -1) {
      const updatedTargetLine = { ...updatedLine[targetIndex] }
      updatedTargetLine[field] = isDrawer ? e : e.target.value
      updatedLine[targetIndex] = updatedTargetLine
      dataQuotes.set("PricePlanDetailList", updatedLine)
      setDataQuotes(new Map(dataQuotes))
    }
  }  

  const removeLineZone = (Id) => {
    const listPricePlanDetail = dataQuotes.get("PricePlanDetailList")
    if (listPricePlanDetail.length <= 1) {
      ctx.toastMessages('error', '', t("ErrorDeletingLine"))
    } else {
      const updateZones = dataQuotes.get("PricePlanDetailList").filter(zone => zone.Id !== Id)
      dataQuotes.set("PricePlanDetailList", updateZones)
      setDataQuotes(new Map(dataQuotes))
    }
  }

  return (
    <>
      <div className='divCardPriceTable'>
        <div className='divLabelPriceTable'>
          <div className='divInteriorLabelPriceTable'>
            <img src="/icons/svgsDaNet/logo-euro.svg"
              style={{ width: '35px', marginRight: '10px', filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
              alt="Price Table" />
            {t("PriceTable")}
          </div>
          <div className='divInteriorButtonAddTable'>
            <M_Button
              onClick={addDefaultTable}
              label={t("AddTablePrice")}
              icon={<img src="/icons/svgsDaNet/file-plus.svg"
                style={{ filter: 'invert(8%) sepia(97%) saturate(6380%) hue-rotate(353deg) brightness(95%) contrast(105%)', width: '24px' }}
                alt="save" />
              }
              borderColor={'var(--color-grey)'}
            />
          </div>
        </div>
        <div className='divHeaderPriceTable'>
          {tablesRange.map((table, index) => (
            <div key={index}>
              <div className='divInteriorHeaderPriceTable'>
                <div className='divNamePriceTable'>
                  {formRangeKilometers.map((value, key) => (
                    <div key={key} className='inputNamePriceTable'>
                      {value.Type === 'string' ? (
                        <M_InputTextField
                          required={true}
                          label={value.Name}
                          type={'text'}
                          maxNumbers={50}
                          onChange={(e) => addRangeKilometers(e, index)}
                          value={dataQuotes.get("PriceTableList") ? dataQuotes?.get("PriceTableList")[index]?.Name : '' || ''}
                        />
                      ) : ""}
                    </div>
                  ))}
                </div>
                <div className='divButtonsPriceTable'>
                  <M_Button
                    label={t("AddTier")}
                    icon={<img src="/icons/svgsDaNet/add-circle.svg"
                      style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }}
                      alt="save" />
                    }
                    borderColor={'var(--color-grey)'}
                    onClick={() => addLineToTable(index)}
                  />
                  {tablesRange.length > 1 && (
                    <M_Button
                      label={t("RemoveTable")}
                      icon={<img src="/icons/svgsDaNet/trash-2.svg"
                        style={{ filter: 'invert(11%) sepia(68%) saturate(6715%) hue-rotate(359deg) brightness(93%) contrast(115%)', width: '24px' }}
                        alt="save" />
                      }
                      borderColor={'var(--color-grey)'}
                      onClick={() => removeTable(table.id)}
                    />
                  )}
                </div>
              </div>
              <div className='divTablePriceTable'>
                <TableRangeKilometers
                  key={index}
                  id={table.id}
                  PriceTableDetailList={table.PriceTableDetailList}
                  setRowRange={(newRowRange) => RowChangeValue(index, newRowRange)}
                  columnsRange={columnsRange}
                  dataQuotes={dataQuotes}
                  setDataQuotes={setDataQuotes}
                  operation={operation}
                  firstRowAdded={firstRowAdded}
                  optionsRange={optionsRange}
                />
                {index !== tablesRange.length - 1 && <div className='dividerTablesPriceTable'></div>}
              </div>
            </div>

          ))}
        </div>
      </div >

      <div className='displayCardsZoneCosts'>
        <div className='divCardZone'>
          <div className='divLabelZoneAdditionals'>
            <img src="/icons/svgsDaNet/globe.svg"
              style={{ width: '30px', marginRight: '10px', filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
              alt="Zone" />
            {t("Zones")}
          </div>
          <div className='divButtonAddZoneCost'>
            <M_Button
              label={t("AddZone")}
              icon={<img src="/icons/svgsDaNet/add-circle.svg"
                style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }}
                alt="save" />
              }
              borderColor={'var(--color-grey)'}
              onClick={addLineZone}
            />
          </div>
          <div className='divIconsZone'>
            <div className='divInteriorIconsZone'>
              <img src="/icons/svgsDaNet/map-pin.svg"
                style={{ width: '20px' }}
                alt="From Zone" />
              {t("FromZone")}
            </div>
            <div className='divInteriorIconsZone'>
              <img src="/icons/svgsDaNet/flag.svg"
                style={{ width: '20px' }}
                alt="To Zone" />
              {t("ToZone")}
            </div>
            <div className='divInteriorIconsZone'>
              <img src="/icons/svgsDaNet/logo-euro.svg"
                style={{ width: '25px' }}
                alt="Price Table" />
              {t("PriceTable")}
            </div>
          </div>

          <div className='divLinesZone'>
            {dataQuotes.get("PricePlanDetailList")?.map((line, index) => (
              <div key={line?.Id ?? index} className='divGlobalSelectZones'>
                <div className='divSelectZones' >
                  <div>
                    <M_DrawerTableTextField
                      required={true}
                      entity={"Pricezone"}
                      value={line?.FromPriceZoneId ?
                        {
                          PriceZoneId: line?.FromPriceZoneId,
                          ZoneCode: line?.ZoneCode,
                          Name: line.FromPriceZone,
                        } : null}
                      filterField={'Name'}
                      labelFields={['Name']}
                      onSubmitValue={obj => {
                        if (obj) {
                          handleZoneChange(obj.PriceZoneId, line.Id, 'FromPriceZoneId', true)
                          handleZoneChange(obj.ZoneCode, line.Id, 'ZoneCode', true)
                          handleZoneChange(obj.Name, line.Id, 'FromPriceZone', true)
                        } else {
                          handleZoneChange(null, line.Id, 'FromPriceZoneId', true)
                          handleZoneChange(null, line.Id, 'ZoneCode', true)
                          handleZoneChange(null, line.Id, 'FromPriceZone', true)
                        }
                      }}
                      valueField={'FromPriceZoneId'}
                    />
                  </div>
                  <div>
                    <M_DrawerTableTextField
                      required={true}
                      entity={"Pricezone"}
                      value={line?.ToPriceZoneId ?
                        {
                          PriceZoneId: line?.ToPriceZoneId,
                          ZoneCode: line?.ZoneCode,
                          Name: line.ToPriceZone,
                        } : null}
                      filterField={'Name'}
                      labelFields={['Name']}
                      onSubmitValue={obj => {
                        if (obj) {
                          handleZoneChange(obj.PriceZoneId, line.Id, 'ToPriceZoneId', true)
                          handleZoneChange(obj.ZoneCode, line.Id, 'ZoneCode', true)
                          handleZoneChange(obj.Name, line.Id, 'ToPriceZone', true)
                        } else {
                          handleZoneChange(null, line.Id, 'ToPriceZoneId', true)
                          handleZoneChange(null, line.Id, 'ZoneCode', true)
                          handleZoneChange(null, line.Id, 'ToPriceZone', true)
                        }
                      }}
                      valueField={'ToPriceZoneId'}
                    />
                  </div>
                  <div>
                    <M_Select
                      value={line.PriceTable || ""}
                      options={optionsZone}
                      onChange={(e) => handleZoneChange(e, line.Id, 'PriceTable')}
                    />
                  </div>
                </div>
                <div className='divDeleteLineZone'>
                  <DeleteOutline
                    style={{ cursor: 'pointer', color: 'var(--color-red)' }}
                    onClick={() => removeLineZone(line.Id)}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>


        <div className='divCardAdditionals'>
          <div className='divLabelZoneAdditionals'>
            <img src="/icons/svgsDaNet/calculator.svg"
              style={{ width: '30px', marginRight: '10px', filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
              alt="Additionals" />
            {t("Additionals")}
          </div>
          <div className='divTableCosts'>
            <TableCostsCustomer rowCost={rowCost} setRowCost={setRowCost} />
          </div>
        </div>
      </div >
      <br /><br />
    </>
  )
}
